import BaseButton from "base/BaseButton";
import React from "react";

const RecipeSortAlphabetically = ({ recipes, onAlphaSort }) => {
  const sortAlphabetically = () => {
    let copy = [...recipes];
    copy.sort((a, b) => a.recipe_name.localeCompare(b.recipe_name));
    onAlphaSort(copy);
  };

  return (
    <BaseButton
      buttonText="Alphabetically"
      handleClick={sortAlphabetically}
      widthClass="w-100"
    />
  );
};

export default RecipeSortAlphabetically;
